"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../utils/constants");

var _TabContent = _interopRequireDefault(require("./_TabContent"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _tabs = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/tabs.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _tabs.default);
/** A **TabGroup** is a collection of **Tab** components.  Each **Tab** is based on a folder
metaphor and is used to separate content into different sections.
They should be ordered to create a visual hierarchy based on priority. */

var TabGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TabGroup, _Component);

  var _super = _createSuper(TabGroup);

  function TabGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TabGroup);
    _this = _super.call(this, props);

    _this.handleTabSelection = function (event, index) {
      event.preventDefault();

      _this.setState({
        selectedIndex: index
      });

      _this.props.onTabClick(event, index);
    };

    _this.cloneElement = function (child, index) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        onClick: _this.handleTabSelection,
        selected: _this.state.selectedIndex === index,
        index: index
      });
    };

    _this.renderTabs = function () {
      var _context;

      return (0, _map.default)(_context = _react.default.Children.toArray(_this.props.children)).call(_context, function (child, index) {
        return _this.cloneElement(child, index);
      });
    };

    _this.renderContent = function () {
      var _context2;

      return (0, _map.default)(_context2 = _react.default.Children.toArray(_this.props.children)).call(_context2, function (child, index) {
        return /*#__PURE__*/_react.default.createElement(_TabContent.default, (0, _extends2.default)({}, child.props.tabContentProps, {
          key: index,
          selected: _this.state.selectedIndex === index
        }), child.props.children);
      });
    };

    _this.state = {
      selectedIndex: props.selectedIndex
    };
    return _this;
  }

  (0, _createClass2.default)(TabGroup, [{
    key: "render",
    value: function render() {
      var _context3;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cssNamespace = _this$props.cssNamespace,
          selectedIndex = _this$props.selectedIndex,
          size = _this$props.size,
          tabGroupProps = _this$props.tabGroupProps,
          onTabClick = _this$props.onTabClick,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "cssNamespace", "selectedIndex", "size", "tabGroupProps", "onTabClick"]); // css classes to use for tab group

      var tabGroupClasses = classnames("".concat(cssNamespace, "-tabs"), (0, _defineProperty2.default)({}, (0, _concat.default)(_context3 = "".concat(cssNamespace, "-tabs--")).call(_context3, size), size), className);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({}, rest, {
        className: tabGroupClasses,
        role: "tablist"
      }), this.renderTabs(children)), this.renderContent(children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps || {}; // Compare the incoming prop to previous prop

      var selectedIndex = prevProps.selectedIndex !== props.selectedIndex ? props.selectedIndex : state.selectedIndex;
      return {
        // Store the previous props in state
        prevProps: props,
        selectedIndex: selectedIndex
      };
    } // set selected tab

  }]);
  return TabGroup;
}(_react.Component);

TabGroup.displayName = 'TabGroup';
TabGroup.defaultProps = {
  selectedIndex: 0,
  size: 'l',
  onTabClick: function onTabClick() {}
};
process.env.NODE_ENV !== "production" ? TabGroup.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** The index of the selected tab */
  selectedIndex: _propTypes.default.number,

  /** Size of the component: 's',
  'm',
  'l',
  'xl',
  'xxl' */
  size: _propTypes.default.oneOf(_constants.TAB_SIZES),
  tabGroupProps: _propTypes.default.object,

  /**
   * Callback function; triggered when the user selects a tab by clicking on pressing `enter`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {number} index - selected tab index.
   * @returns {void}
   * */
  onTabClick: _propTypes.default.func
} : void 0;

var _default = (0, _withStyles.default)(TabGroup);

exports.default = _default;